import { all, takeEvery } from 'redux-saga/effects';

import { GET_USER_REQUEST, LOGOUT } from '../Actions/AuthAction';
import { GET_CSV_REPORT_REQUEST } from '../Actions/OPReportingAction';
import { RETARGETING_CONFIG_REQUEST } from '../Actions/RetargetingConfigAction';
import { TOAST_INIT } from '../Actions/ToastAction';
import {
  AddNewUserSaga,
  ChangeRoleAccessScrrenSaga,
  ChangeUserRoleSaga,
  DeleteUserSaga,
  EditReportCradicialsSaga,
  GetLoggerDataSaga,
  GetReportCradicialsSaga,
  GetUsersListSaga,
  EditUserSaga,
  DuplicateUserSaga,
  getUserPermissionsSaga,
  uploadDomainWhitelistSaga,
  uploadAppWhitelistSaga,
  getDomainWhitelistCSVSaga,
  getAppWhitelistCSVSaga,
  deleteWhitelistSaga,
  removeUserTokenSaga,
  getNotificationsListSaga,
  clearNotificationsListSaga,
  GetAdminAdvSaga,
  GetAdminS3FoldersAndFilesSaga,
  GetNoasCounterSaga
} from './AdminSaga';
import { LoginSaga, LogoutSaga } from './AuthSaga';
import { ImageUploaderSaga, S3UploaderSaga } from './ImageUploaderSaga';
import { GetCsvReportSaga } from './OPReportingSaga';
import { RetargetingConfigSaga } from './RetargetingConfigSaga';
import { ToastSaga } from './ToastSaga';
import {
  ADD_NEW_CAMPAIGNS_REQUEST,
  DELETE_TAG_CAMPAIGN_REQUEST,
  GET_CAMPAIGNS_LIST_REQUEST,
  GET_EDIT_TAG_DATA_REQUEST,
  GET_TAG_GENERATOR_REQUEST,
  UPDATE_EDIT_TAG_DATA_REQUEST
} from '../Actions/TagGeneratorAction';
import {
  AddNewCampaignSaga,
  DeleteTagSaga,
  GetCampaignsListSaga,
  GetEditTagDataSaga,
  GetTagGeneratorSaga,
  UpdateEditTagDataSaga
} from './TagGeneratorSaga';
import {
  ADD_NEW_SCRIPT_REQUEST,
  DELETE_SCRIPT_DATA_REQUEST,
  EDIT_SCRIPT_DATA_REQUEST,
  GET_NAME_LIST_REQUEST,
  GET_NAME_VALUE_REQUEST,
  GET_SCRIPT_REQUEST
} from '../Actions/JsConfigAction';
import {
  AddNewScriptSaga,
  DeleteScriptDataSaga,
  EditScriptDataSaga,
  GetNameListSaga,
  GetNameValueSaga,
  GetScriptSaga
} from './JsConfigSaga';
import {
  ADD_NEW_USER_REQUEST,
  CHANGE_ROLE_ACCESS_SCRREN_REQUEST,
  CHANGE_USER_ROLE_REQUEST,
  DELETE_USER_REQUEST,
  EDIT_CRADICIALS_REQUEST,
  GET_CRADICIALS_REQUEST,
  GET_LOGGER_DATA_REQUEST,
  GET_USERS_LIST_REQUEST,
  EDIT_USER_REQUEST,
  DUPLICATE_USER_REQUEST,
  GET_USER_PERMISSION_DATA_REQUEST,
  UPLOAD_DOMAIN_WHITELIST_REQUEST,
  UPLOAD_APP_WHITELIST_REQUEST,
  GET_DOMAINWHITELIST_CSV_DATA_REQUEST,
  GET_APPWHITELIST_CSV_DATA_REQUEST,
  DELETE_WHITELIST_CJSC_REQUEST,
  REMOVE_USER_TOKEN_REQUEST,
  GET_NOTIFICATIONS_REQUEST,
  CLEARALL_NOTIFICATIONS_REQUEST,
  C_GET_ADVERTISER_REQUEST,
  C_ADMIN_GET_S3FILESANDFOLDERS_REQUEST
} from '../Actions/AdminActions';
import {
  IMAGE_UPLOADER_REQUEST,
  S3_UPLOADER_REQUEST
} from '../Actions/ImageUploader';
import { GetRolesListSaga } from './RolesSaga';
import { GET_ROLE_LIST_REQUEST } from '../Actions/RoleAction';
import {
  ADD_NEW_DOMAIN_REQUEST,
  GET_DOMAIN_LIST_REQUEST
} from '../Actions/DomainAction';
import {
  AddNewDomainSaga,
  GetDomainListSaga
} from './DomainSaga';
import { ADD_NEW_CAMPAGIN_REQUEST, CJSC_EXPORT_TO_CSV_REQUEST, DELETE_CAMPAGIN_REQUEST, PAUSE_CAMPAIGN_REQUEST, RESUME_CAMPAIGN_REQUEST, GET_ALL_CAMAGINS_REQUEST, GET_MULITPLE_CJSCID_LIST_REQUEST, UPDATE_CAMPAIGN_REQUEST } from '../Actions/CampaignsActions';
import { addNewCampaginSaga, cjscListExportToCsvSaga, deleteCampaginSaga,pauseCampaignSaga, resumeCampaignSaga, GetAllCampaignsSaga, getCJSCIdDropdownListSaga, updateCampaignSaga } from './CampaignsSaga';
import { getSubUsersListSaga } from './UserManagementSaga';
import { ADD_NEW_C_TARGETING_REQUEST,GET_C_TARGETING_LIST_REQUEST,GET_C_TARGETING_SEGMENTS_REQUEST } from '../Actions/CtargetingActions';
import { AddNewCTargeting,GetCTargetingList,GetCTargetingSegments} from './Ctargeting';
import { GET_EVENTS_REQUEST } from '../Actions/EventsLoggerActions';
import { GetEventsSaga } from './EventsLoggerSaga';
import { GET_NOAS_COUNTER_REQUEST } from '../Actions/AdminActions';
import { GET_CAMPAIGNS_REQUEST, GET_OVERVIEW_REQUEST } from '../Actions/AdsDashboardActions'
import { GetCampaignsSaga, GetOverviewSaga } from './AdsDashboardSaga';
import { EXPORT_IMPS_REQUEST, GET_IMPS_REQUEST } from '../Actions/AdsImpressionsActions';
import { GetCImpSaga, exportCIMPDataSaga } from './AdsImpressionsSaga';
import { GET_UING_REQUEST, GetUserInfoNG, } from '../Actions/UserInfoNGActions';
import { GetUserInfoNGSaga, GetUserInfoNGCSVSaga } from './UserInfoNGSaga';
import { GET_UI_REQUEST } from '../Actions/UserInfoActions';
import { GetUserInfoSaga} from './UserInfoSaga';
import { GET_UIV2_REQUEST } from '../Actions/UserInfoV2Actions';
import { GetUserInfoV2Saga } from './UserInfoV2Saga';
import { SET_YANDEX_DATA_REQUEST, GET_YANDEX_DATA_REQUEST, ADD_NEW_YANDEX_REQUEST, ADD_NEW_YANDEX_CSV_REQUEST} from '../Actions/YandexActions';
import { SetYandexDataSaga, GetYandexDataSaga, AddNewYandexSaga, AddNewYandexCSVSaga } from './YandexSaga';
import { GET_LINE_INFO_REQUEST, RESTART_LINE_ITEM_IPS_REQUEST, SET_LINE_ITEM_IPS_REQUEST } from '../Actions/CLineItemActions';
import { GET_LINE_INFO_DEMO_REQUEST, RESTART_LINE_ITEM_IPS_DEMO_REQUEST, SET_LINE_ITEM_IPS_DEMO_REQUEST } from '../Actions/CLineItemDemoActions';
import { GetLineInfoSaga, SetLineItemIPsSaga, restartLineItemIPsSaga } from './ClineItemsSaga';
import { GetLineInfoDemoSaga, SetLineItemIPsDemoSaga, restartLineIPsDemoSaga } from './ClineItemsDemoSaga';
import { GET_ADVERTISER_REQUEST, GET_S3FILESANDFOLDERS_REQUEST, UPLOAD_FILES_REQUEST, UPLOAD_TO_DSP_REQUEST, VALIDATE_FOLDER_NAME_REQUEST } from '../Actions/OPCreativeUploadActions';
import { GetAdvSaga, GetS3FoldersAndFilesSaga, validateFolderNameSaga,uploadToDSPSaga,uploadToS3Saga } from './OPCreativeUploadSaga';
import { GLU_CREATE_CAMPAIGN_REQUEST, GLU_GET_CAMPAIGNS_LIST_REQUEST, GLU_GET_CAMPAIGN_STATUS_REQUEST } from '../Actions/GLUActions';
import { createCampaignSaga, getCampaignStatusSaga, getCampaignsListSaga } from './GLUSaga';
import { uploadBannerImageSaga } from './HtmlbannerSaga';
import { UPLOAD_BANNER_IMAGE_REQUEST } from '../Actions/HtmlBannerActions';
import { USAGE_REPORT_REQUEST } from '../Actions/ReportsActions';
import { usageReportSaga } from './ReportsSaga';
import { GET_BIDS_REQUEST } from '../Actions/CBidActions';
import { GetCBidSaga } from './BidRequestsSaga';
import { GET_REALTIME_REQUEST } from '../Actions/RealtimeMonitorActions';
import { GetRealtimeMonitorSaga } from './RealtimeMonitorSaga';
import { GET_SUB_USERS_LIST_REQUEST } from '../Actions/UserManagementActions';
import { CHANGE_USER_COUNTRIES_REQUEST } from '../Actions/UserManagementActions';
import { changeUserCountriesSaga } from './UserManagementSaga';
import { C_GET_S3FILESANDFOLDERS_REQUEST,C_UPLOAD_FILES_REQUEST,C_UPLOAD_TO_DSP_REQUEST,C_VALIDATE_FOLDER_NAME_REQUEST,C_GET_LINEITEMS_REQUEST, getLineItems} from '../Actions/CreativeUploadActions';
import {GetCCS3FoldersAndFilesSaga,validateCCFolderNameSaga,uploadCCToS3Saga,uploadCCToDSPSaga,GetLinesSaga} from './CreativeUploadSaga'
import { GET_HASH_RESULT_REQUEST } from '../Actions/HashActions';
import { GetHashResultSaga } from './HashSaga';
import { update } from 'lodash';


function* rootSagas() {
  yield all([
    takeEvery(GET_USER_REQUEST, LoginSaga),
    takeEvery(LOGOUT, LogoutSaga),
    takeEvery(TOAST_INIT, ToastSaga),
    takeEvery(GET_CAMPAIGNS_LIST_REQUEST, GetCampaignsListSaga),
    takeEvery(GET_TAG_GENERATOR_REQUEST, GetTagGeneratorSaga),
    takeEvery(DELETE_TAG_CAMPAIGN_REQUEST,DeleteTagSaga),
    takeEvery(ADD_NEW_CAMPAIGNS_REQUEST, AddNewCampaignSaga),
    takeEvery(IMAGE_UPLOADER_REQUEST, ImageUploaderSaga),
    takeEvery(S3_UPLOADER_REQUEST, S3UploaderSaga),
    takeEvery(GET_CSV_REPORT_REQUEST, GetCsvReportSaga),
    takeEvery(RETARGETING_CONFIG_REQUEST, RetargetingConfigSaga),
    takeEvery(GET_EDIT_TAG_DATA_REQUEST, GetEditTagDataSaga),
    takeEvery(UPDATE_EDIT_TAG_DATA_REQUEST, UpdateEditTagDataSaga),
    takeEvery(GET_LOGGER_DATA_REQUEST, GetLoggerDataSaga),
    takeEvery(GET_USERS_LIST_REQUEST, GetUsersListSaga),
    takeEvery(GET_NAME_LIST_REQUEST, GetNameListSaga),
    takeEvery(GET_NAME_VALUE_REQUEST, GetNameValueSaga),
    takeEvery(GET_SCRIPT_REQUEST, GetScriptSaga),
    takeEvery(ADD_NEW_SCRIPT_REQUEST, AddNewScriptSaga),
    takeEvery(EDIT_SCRIPT_DATA_REQUEST, EditScriptDataSaga),
    takeEvery(DELETE_SCRIPT_DATA_REQUEST, DeleteScriptDataSaga),
    takeEvery(EDIT_CRADICIALS_REQUEST, EditReportCradicialsSaga),
    takeEvery(GET_CRADICIALS_REQUEST, GetReportCradicialsSaga),
    takeEvery(GET_ROLE_LIST_REQUEST, GetRolesListSaga),
    takeEvery(CHANGE_USER_ROLE_REQUEST, ChangeUserRoleSaga),
    takeEvery(CHANGE_ROLE_ACCESS_SCRREN_REQUEST, ChangeRoleAccessScrrenSaga),
    takeEvery(ADD_NEW_DOMAIN_REQUEST, AddNewDomainSaga),
    takeEvery(GET_DOMAIN_LIST_REQUEST, GetDomainListSaga),
    takeEvery(GET_ALL_CAMAGINS_REQUEST, GetAllCampaignsSaga),
    takeEvery(DELETE_CAMPAGIN_REQUEST, deleteCampaginSaga),
    takeEvery(PAUSE_CAMPAIGN_REQUEST,pauseCampaignSaga),
    takeEvery(RESUME_CAMPAIGN_REQUEST,resumeCampaignSaga),
    takeEvery(UPDATE_CAMPAIGN_REQUEST, updateCampaignSaga),
    takeEvery(ADD_NEW_CAMPAGIN_REQUEST, addNewCampaginSaga),
    takeEvery(ADD_NEW_USER_REQUEST, AddNewUserSaga),
    takeEvery(EDIT_USER_REQUEST, EditUserSaga),
    takeEvery(DUPLICATE_USER_REQUEST, DuplicateUserSaga),
    takeEvery(DELETE_USER_REQUEST,DeleteUserSaga),
    takeEvery(ADD_NEW_C_TARGETING_REQUEST,AddNewCTargeting),
    takeEvery(GET_EVENTS_REQUEST,GetEventsSaga),
    takeEvery(GET_CAMPAIGNS_REQUEST,GetCampaignsSaga),
    takeEvery(GET_OVERVIEW_REQUEST,GetOverviewSaga),
    takeEvery(GET_IMPS_REQUEST,GetCImpSaga),
    takeEvery(GET_LINE_INFO_REQUEST,GetLineInfoSaga),
    takeEvery(SET_LINE_ITEM_IPS_REQUEST,SetLineItemIPsSaga),
    takeEvery(GET_LINE_INFO_DEMO_REQUEST,GetLineInfoDemoSaga),
    takeEvery(SET_LINE_ITEM_IPS_DEMO_REQUEST,SetLineItemIPsDemoSaga),
    takeEvery(GET_ADVERTISER_REQUEST,GetAdvSaga),
    takeEvery(GET_S3FILESANDFOLDERS_REQUEST,GetS3FoldersAndFilesSaga),
    takeEvery(VALIDATE_FOLDER_NAME_REQUEST,validateFolderNameSaga),
    takeEvery(UPLOAD_TO_DSP_REQUEST,uploadToDSPSaga),
    takeEvery(UPLOAD_FILES_REQUEST,uploadToS3Saga),
    takeEvery(GLU_GET_CAMPAIGNS_LIST_REQUEST, getCampaignsListSaga),
    takeEvery(GLU_GET_CAMPAIGN_STATUS_REQUEST, getCampaignStatusSaga),
    takeEvery(GLU_CREATE_CAMPAIGN_REQUEST, createCampaignSaga),
    takeEvery(GET_C_TARGETING_LIST_REQUEST, GetCTargetingList),
    takeEvery(GET_USER_PERMISSION_DATA_REQUEST, getUserPermissionsSaga),
    takeEvery(UPLOAD_DOMAIN_WHITELIST_REQUEST, uploadDomainWhitelistSaga),
    takeEvery(UPLOAD_APP_WHITELIST_REQUEST, uploadAppWhitelistSaga),
    takeEvery(GET_DOMAINWHITELIST_CSV_DATA_REQUEST,getDomainWhitelistCSVSaga),
    takeEvery(GET_APPWHITELIST_CSV_DATA_REQUEST,getAppWhitelistCSVSaga),
    takeEvery(GET_MULITPLE_CJSCID_LIST_REQUEST,getCJSCIdDropdownListSaga),
    takeEvery(GET_SUB_USERS_LIST_REQUEST, getSubUsersListSaga),
    takeEvery(CJSC_EXPORT_TO_CSV_REQUEST,cjscListExportToCsvSaga),
    takeEvery(DELETE_WHITELIST_CJSC_REQUEST,deleteWhitelistSaga),
    takeEvery(RESTART_LINE_ITEM_IPS_DEMO_REQUEST,restartLineIPsDemoSaga),
    takeEvery(RESTART_LINE_ITEM_IPS_REQUEST,restartLineItemIPsSaga),
    takeEvery(EXPORT_IMPS_REQUEST,exportCIMPDataSaga),
    takeEvery(UPLOAD_BANNER_IMAGE_REQUEST,uploadBannerImageSaga),
    takeEvery(REMOVE_USER_TOKEN_REQUEST,removeUserTokenSaga),
    takeEvery(USAGE_REPORT_REQUEST,usageReportSaga),
    takeEvery(GET_NOTIFICATIONS_REQUEST,getNotificationsListSaga),
    takeEvery(CLEARALL_NOTIFICATIONS_REQUEST,clearNotificationsListSaga),
    takeEvery(GET_BIDS_REQUEST, GetCBidSaga),
    takeEvery(GET_REALTIME_REQUEST, GetRealtimeMonitorSaga),
    takeEvery(CHANGE_USER_COUNTRIES_REQUEST, changeUserCountriesSaga),
    takeEvery(C_GET_ADVERTISER_REQUEST,GetAdminAdvSaga),
    takeEvery(C_ADMIN_GET_S3FILESANDFOLDERS_REQUEST,GetAdminS3FoldersAndFilesSaga),
    takeEvery(C_GET_S3FILESANDFOLDERS_REQUEST,GetCCS3FoldersAndFilesSaga),
    takeEvery(C_VALIDATE_FOLDER_NAME_REQUEST,validateCCFolderNameSaga),
    takeEvery(C_UPLOAD_FILES_REQUEST,uploadCCToS3Saga),
    takeEvery(C_UPLOAD_TO_DSP_REQUEST,uploadCCToDSPSaga),
    takeEvery(C_GET_LINEITEMS_REQUEST,GetLinesSaga),
    takeEvery(GET_UING_REQUEST,GetUserInfoNGSaga),
    takeEvery(GET_UI_REQUEST,GetUserInfoSaga),
    takeEvery(GET_UIV2_REQUEST,GetUserInfoV2Saga),
    takeEvery(GET_C_TARGETING_SEGMENTS_REQUEST,GetCTargetingSegments),
    takeEvery(SET_YANDEX_DATA_REQUEST,SetYandexDataSaga),
    takeEvery(GET_YANDEX_DATA_REQUEST,GetYandexDataSaga),
    takeEvery(ADD_NEW_YANDEX_REQUEST, AddNewYandexSaga),
    takeEvery(ADD_NEW_YANDEX_CSV_REQUEST,AddNewYandexCSVSaga),
    takeEvery(GET_NOAS_COUNTER_REQUEST, GetNoasCounterSaga),
    //takeEvery(EXPORT_BIDS_REQUEST, exportCBIDDataSaga)
    takeEvery(GET_HASH_RESULT_REQUEST,GetHashResultSaga),
  ])
}

export default rootSagas;
